import React from 'react';

import { PromoCountryItemPanel } from './PromoCountryItemPanel';

const PromoCountryItemWithCode = (props) => {
    const country = props.country;
    const prefix = country.phone_prefix;
    const code = country.code_a2.toLowerCase();

    const click = () => {
        props.onCountryItemClick(code, prefix, country.name);
    };

    return (
        <PromoCountryItemPanel
            flagIconName={code}
            isSelectedCountry={props.iso2 === code}
            onClick={click}
            countryName={country.name}
            countryPrefix={prefix}
            query={props.query}
        />
    );
};

export default PromoCountryItemWithCode;
